import React, { useState, useEffect } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { SERVER_URL } from "../../api";
import "./AnnouncementPopup.css";

const POPUP_STORAGE_KEY = "ppshope_popup_views";

// ອ່ານຈຳນວນຄັ້ງທີ່ user ເຫັນ popup ຈາກ localStorage
const getPopupViews = () => {
  try {
    const raw = localStorage.getItem(POPUP_STORAGE_KEY);
    if (raw && raw !== "undefined" && raw !== "null") {
      return JSON.parse(raw);
    }
  } catch (e) {
    // ignore
  }
  return {};
};

const setPopupViews = (views) => {
  localStorage.setItem(POPUP_STORAGE_KEY, JSON.stringify(views));
};

export default function AnnouncementPopup() {
  const { t } = useTranslation();
  const [popups, setPopups] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [isClosing, setIsClosing] = useState(false);

  useEffect(() => {
    fetchPopups();
  }, []);

  const fetchPopups = async () => {
    try {
      // ★ ໃຊ້ sessionStorage cache 5 ນາທີ ເພື່ອບໍ່ fetch ທຸກຄັ້ງ
      const CACHE_KEY = "cache_popups_active";
      const CACHE_TTL = 5 * 60 * 1000;
      try {
        const raw = sessionStorage.getItem(CACHE_KEY);
        if (raw) {
          const entry = JSON.parse(raw);
          if (Date.now() - entry.ts < CACHE_TTL) {
            const allPopups = entry.data || [];
            const views = getPopupViews();
            const filtered = allPopups.filter((p) => {
              const viewCount = views[p._id] || 0;
              if (p.maxShowPerUser === 0) return true;
              return viewCount < p.maxShowPerUser;
            });
            if (filtered.length > 0) {
              setPopups(filtered);
              setCurrentIndex(0);
              setVisible(true);
            }
            return;
          }
        }
      } catch {}

      const res = await axios.get(SERVER_URL + "/api/v1/popups/active");
      const allPopups = res.data?.data || [];

      // ★ ເກັບ cache
      try { sessionStorage.setItem(CACHE_KEY, JSON.stringify({ data: allPopups, ts: Date.now() })); } catch {}

      const views = getPopupViews();

      // ກັ່ນຕອງ popup ທີ່ user ຍັງບໍ່ເກີນ maxShowPerUser
      const filtered = allPopups.filter((p) => {
        const viewCount = views[p._id] || 0;
        // maxShowPerUser = 0 ໝາຍຄວາມວ່າ ບໍ່ຈຳກັດ
        if (p.maxShowPerUser === 0) return true;
        return viewCount < p.maxShowPerUser;
      });

      if (filtered.length > 0) {
        setPopups(filtered);
        setCurrentIndex(0);
        setVisible(true);
      }
    } catch (err) {
      // ບໍ່ສະແດງ error — popup ເປັນ optional
      console.log("Popup fetch skipped");
    }
  };

  const handleClose = () => {
    setIsClosing(true);
    // ບັນທຶກວ່າ user ເຫັນ popup ນີ້ແລ້ວ
    const views = getPopupViews();
    const current = popups[currentIndex];
    if (current) {
      views[current._id] = (views[current._id] || 0) + 1;
      setPopupViews(views);
    }

    setTimeout(() => {
      // ຖ້າມີ popup ຕໍ່ໄປ → ສະແດງ
      if (currentIndex + 1 < popups.length) {
        setCurrentIndex(currentIndex + 1);
        setIsClosing(false);
      } else {
        setVisible(false);
        setIsClosing(false);
      }
    }, 300);
  };

  const handleLinkClick = (url) => {
    if (url) {
      window.open(url, "_blank");
    }
    handleClose();
  };

  if (!visible || popups.length === 0) return null;

  const popup = popups[currentIndex];
  const AWS_URL = "https://file-and-images.ppshope.com/images/";
  const imageUrl = popup.imageUrl
    ? popup.imageUrl.startsWith("http")
      ? popup.imageUrl
      : AWS_URL + (popup.imageUrl.startsWith("images/") ? popup.imageUrl.replace("images/", "") : popup.imageUrl)
    : null;

  return (
    <div className={`announcement-overlay ${isClosing ? "closing" : ""}`}>
      <div className={`announcement-popup ${isClosing ? "closing" : ""}`}>
        {/* ປຸ່ມ X ປິດ */}
        <button className="announcement-close-x" onClick={handleClose}>
          ✕
        </button>

        {/* ຮູບພາບ */}
        {imageUrl && (
          <div
            className="announcement-image-wrapper"
            onClick={() => popup.linkUrl && handleLinkClick(popup.linkUrl)}
            style={{ cursor: popup.linkUrl ? "pointer" : "default" }}
          >
            <img src={imageUrl} alt={popup.title} className="announcement-image" />
          </div>
        )}

        {/* ເນື້ອຫາ */}
        <div className="announcement-content">
          {popup.title && <h3 className="announcement-title">{popup.title}</h3>}
          {popup.message && <p className="announcement-message">{popup.message}</p>}
        </div>

        {/* ປຸ່ມ */}
        <div className="announcement-actions">
          {popup.linkUrl && (
            <button
              className="announcement-btn announcement-btn-primary"
              onClick={() => handleLinkClick(popup.linkUrl)}
            >
              {t("AnnounceTitle")}
            </button>
          )}
          <button className="announcement-btn announcement-btn-close" onClick={handleClose}>
            {popup.buttonText || t("AnnounceClose")}
          </button>
        </div>

        {/* Indicator ຖ້າມີຫຼາຍ popup */}
        {popups.length > 1 && (
          <div className="announcement-indicator">
            {popups.map((_, idx) => (
              <span
                key={idx}
                className={`indicator-dot ${idx === currentIndex ? "active" : ""}`}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
